// import { GlobeAltIcon } from "@heroicons/react/24/outline";
import React, { useState, useEffect } from "react";
import cargandoCard from "../../../components/cargando-card";
import { useHistory, } from "react-router-dom";
import spinner from "../../../assets/spinner4.svg";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import { actualizarConfiguracionRefugio, obtenerConfiguracionRefugio } from "../../../api/api-configuracion-refugio";
import LoadingComponent from '../../../components/loading-component';
import moment from "moment";
import { guardarImagenMascota } from "../../../api/api-mascota";
import { COLOR_AZUL_MAIN } from "../../../utils/const/colors-const";
import { deshabilitarQR, obtenerQRRefugio, registrarQR } from "../../../api/api-qr";
import { compressAndConvertToBase64 } from "../../../utils/shared-functions";

export default function QR() {

    // const { t, i18n } = useTranslation();
    // const location = useLocation();
    const history = useHistory();
    const [cargandoPage, setCargandoPage] = useState(true);
    // const [formData, setFormData] = useState({
    //     id: 0,
    // });
    const primaryColorButton = COLOR_AZUL_MAIN;
    const [loading, setLoading] = useState(false);
    // const [urlLogo, setUrlLogo] = useState(null);
    const [body, setBody] = useState(null);
    const [popUpLoadingVisible, setPopUpLoadingVisible] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const hoverColor = COLOR_AZUL_MAIN;


    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const config = await obtenerQRRefugio();
            console.log('config');
            console.log(config);
            if (config.error === false && config.body !== null) {
                setBody(config.body);
                // if (config.body.urlQR !== null) {
                //     // setImages([config.body.urlLogo]);
                //     setUrlLogo(config.body.urlQR);
                // }
            }
            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const handleSave = async () => {
        try {
            setPopUpLoadingVisible(true);
            // console.log('handleSave');
            // console.log(formData);
            // console.log('idioma');
            // console.log(idioma);
            let objEnviar = {};
            // objEnviar.id = body.id;
            objEnviar.urlQR = body.urlQR;
            // console.log('objEnviar');
            // console.log(objEnviar);
            // return;

            const resp = await registrarQR(objEnviar);
            // console.log('resp');
            // console.log(resp);
            setPopUpLoadingVisible(false);
            if (resp.error === false) {
                alert("Guardado correctamente");
                handleAtrasClick();
                // return;
            }
            if (resp.error === true) {
                alert("No se pudo Actualizar" + "\n" + resp.message);
            }

            setPopUpLoadingVisible(false);
        } catch (err) {
            console.log('handleSave err');
            console.log(err);
            setPopUpLoadingVisible(false);
        }
    };

    const handleDrop = (event) => {
        if (body !== null && body.urlQR !== null) {
            alert("Solo puedes subir una imagen");
            return;
        }
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file) {
            convertToBase64(file);
        }
    };

    const handleFileSelect = (event) => {
        if (body !== null && body.urlQR !== null) {
            alert("Solo puedes subir una imagen");
            return;
        }
        // console.log("File input event:", event);
        if (!event.target.files) {
            console.error("No files detected in event.target.files.");
            return;
        }

        const file = event.target.files[0];
        // console.log("Selected file:", file);

        if (file) {
            convertToBase64(file);
        } else {
            console.error("No file selected.");
        }
    };

    // Convert image file to Base64
    const convertToBase64 = (file) => {
        const MAX_SIZE = 5 * 1024 * 1024; // 3MB in bytes

        if (file.size > MAX_SIZE) {
            alert("The image is bigger than the allowed size (" + MAX_SIZE + "MB). Please select a smaller file.");
            return;
        }
        compressAndConvertToBase64(file, (base64String) => {
            uploadImage(base64String);
        });

        /*const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            // const base64String = reader.result.split(",")[1]; // Extract only the Base64 data
            // uploadImage(base64String);
            compressAndConvertToBase64(file, (base64String) => {
                uploadImage(base64String);
            });
        };
        reader.onerror = (error) => {
            console.error("Error converting to Base64:", error);
        };*/
    };

    const uploadImage = async (file) => {
        try {
            // console.log('uploadImage');
            // console.log(file);
            setPopUpLoadingVisible(true);
            let objEnviar = {};
            objEnviar.base64 = file;
            objEnviar.nombre = moment().unix() + '.png';
            objEnviar.tipoArchivo = ".png";
            const response = await guardarImagenMascota(objEnviar);
            // console.log('response');
            // console.log(response);
            if (response.error === false) {
                // setImages([...images, response.body.url_fotografia]);
                // setUrlLogo(response.body.url_fotografia);
                setBody({
                    ...body,
                    urlQR: response.body.url_fotografia,
                });
                iniciar();
            } else {
                alert("Upload failed");
            }
            setPopUpLoadingVisible(false);
        } catch (error) {
            console.error("Error uploading image:", error);
            setPopUpLoadingVisible(false);
        }
    };

    const deleteImage = async () => {
        try {
            // setImages(images.filter((img) => img !== imageUrl));
            // setUrlLogo(null);
            // console.log('deleteImage');
            // console.log(body);
            if (body.id === undefined) {
                setBody(null);
                return;
            }
            const confirmed = window.confirm("Seguro que desea eliminar imagen qr?");
            if (confirmed) {
                // console.log("Deleted!");
                // Perform delete action here
                const resp = await deshabilitarQR(body);
                // console.log('resp');
                // console.log(resp);
                setPopUpLoadingVisible(false);
                if (resp.error === false) {
                    alert("Eliminado correctamente");
                    setBody(null);
                    // return;
                }
                if (resp.error === true) {
                    alert("No se pudo Eliminar" + "\n" + resp.message);
                }

                setPopUpLoadingVisible(false);
            } else {
                // console.log("Cancelled!");
            }
        } catch (error) {
            console.error("Error deleting image:", error);
        }
    };

    const render = () => {

        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            return (
                <div className="p-4 ">
                    <br />
                    <div className="grid grid-cols-12 gap-4 pt-4">
                        <label className="block text-gray-600 font-semibold mb-1">QR </label>

                    </div>
                    <br />
                    <div className="grid grid-cols-12 gap-4 pt-4">
                        <div className="col-span-12 ">
                            <div className="max-w-lg mx-auto p-6">
                                {/* Drag and Drop Area */}
                                <div
                                    className="border-2 border-dashed border-gray-400 p-10 text-center cursor-pointer"
                                    onDrop={handleDrop}
                                    onDragOver={(e) => e.preventDefault()}
                                >
                                    <p className="text-gray-600">Drag & Drop an image or</p>
                                    <input type="file" className="hidden" onChange={handleFileSelect} id="fileInput" />
                                    <label htmlFor="fileInput" className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer mt-2 inline-block">
                                        Select File
                                    </label>
                                </div>

                                {/* Uploaded Images List */}
                                <div className="mt-4">
                                    {/* {images.map((image, index) => ( */}
                                    {body !== null &&
                                        <div className="flex items-center justify-between p-2 border rounded mt-2">
                                            <img src={body.urlQR} alt="Uploaded" className="w-16 h-16 object-cover rounded" />
                                            <button className="bg-red-500 text-white px-2 py-1 rounded" onClick={() => deleteImage()}>
                                                Delete
                                            </button>
                                        </div>
                                    }
                                    {/* ))} */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className=" flex items-center justify-between">
                        <button
                            type="button"
                            className={ESTILO_BOTON_LISTAR_ATRAS}
                            onClick={(handleAtrasClick)}
                        >
                            ATRAS
                        </button>
                        {loading === false &&
                            <button
                                type="button"
                                className={`${ESTILO_BOTON_MODAL_ACEPTAR}`}
                                style={{
                                    backgroundColor: isHovered ? hoverColor : primaryColorButton,
                                }}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                                onClick={handleSave}
                            >
                                Guardar
                            </button>
                        }
                        {loading === true &&
                            <button
                                className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300 flex justify-center items-center"
                            >
                                <img className="spinner" alt="spinner" src={spinner} />
                            </button>

                        }
                    </div>
                    <LoadingComponent
                        isOpen={popUpLoadingVisible}
                    />
                </div>
            );
        } catch (err) {
            console.log('Configuracion Empresa render err');
            console.log(err);
            return (
                <div>
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }

    return render();
};

